import EventNoteIcon from "@mui/icons-material/EventNote";
import { GraduationServicePath, SCHEDULES, INDIVIDUAL_CYCLES } from "utils/constants";
import permissions from "app/permissions";
import ListScheduleIndividualCycle from "./List";
import CreateScheduleIndividualCycle from "./Create";
import ShowScheduleIndividualCycle from "./Show/Show";
import EditScheduleIndividualCycle from "./Edit";

export const resources = {
  isMenu: true,
  icon: <EventNoteIcon />,
  name: GraduationServicePath + SCHEDULES + "/" + INDIVIDUAL_CYCLES,
  title: "Разписание - Циклично индивидуално  ",
  list: <ListScheduleIndividualCycle />,
  create: <CreateScheduleIndividualCycle />,
  edit: <EditScheduleIndividualCycle />,
  show: <ShowScheduleIndividualCycle />,
  permission: permissions.canPreviewInternshipSchedules,
};
